import { Block, Flex, Icon } from '@aloft/toolkit-sui';

import { useStreetViewStaticUrl } from '../../hooks/googleMaps/useStreetViewStaticUrl.js';
import { ValuationTablePropertyHeaderProps } from './types.js';

export const ValuationTablePropertyHeaderImage = ({
  photoUrl,
  latitude: lat,
  longitude: lng,
  address,
}: ValuationTablePropertyHeaderProps) => {
  const streetViewStaticUrl = useStreetViewStaticUrl(address, { lat, lng }, !photoUrl);

  return (
    <Block height="88px" width="88px" minWidth={'88px'}>
      {photoUrl ? (
        <img
          height="100%"
          width="100%"
          src={photoUrl}
          style={{ height: '100%', width: '100%', objectFit: 'cover' }}
        />
      ) : (
        <Flex
          justifyContent={'center'}
          alignItems={'center'}
          height="100%"
          width="100%"
          backgroundColor="strokeDefault"
        >
          {streetViewStaticUrl ? (
            <img
              height="100%"
              width="100%"
              src={streetViewStaticUrl}
              style={{ height: '100%', width: '100%', objectFit: 'cover' }}
            />
          ) : (
            <Icon icon="home-2" size="lg" color="strokeActive" />
          )}
        </Flex>
      )}
    </Block>
  );
};
